import { RECAPTCHA_SITE_KEY, ASK_ANALYST_SUBMIT_URL } from './constants.js';

document.addEventListener('DOMContentLoaded', () => {
    // 1. Setup the trigger buttons
    const triggerButtons = document.querySelectorAll('a[href$="#ask-an-analyst"]');
    if (triggerButtons.length === 0) return; // No buttons on this page

    // Check auth state injected by Handlebars
    const isLoggedIn = window.PSA_MEMBER && window.PSA_MEMBER.isLoggedIn;

    triggerButtons.forEach(btn => {
        if (!isLoggedIn) {
            // Mute the button if not logged in
            btn.classList.add('opacity-50', 'pointer-events-none');
            // If it's a Ghost button, append the suffix to the text
            const span = btn.querySelector('span');
            if (span) {
                span.textContent = span.textContent.trim() + ' [access required]';
            } else {
                btn.textContent = btn.textContent.trim() + ' [access required]';
            }
            btn.href = '#';
            btn.title = 'You must be logged in to ask an analyst';
        } else {
            // Setup click listener to open modal
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                openModal();
            });
        }
    });

    // If not logged in, we don't need to setup the modal logic further
    if (!isLoggedIn) return;

    // 2. Setup Modal Logic
    const modal = document.getElementById('ask-analyst-modal');
    if (!modal) return;

    const closeBtn = document.getElementById('ask-analyst-close-btn');
    const successCloseBtn = document.getElementById('ask-analyst-success-close');
    const form = document.getElementById('ask-analyst-form');
    const submitBtn = document.getElementById('ask-analyst-submit-btn');
    const successView = document.getElementById('ask-analyst-success');
    const errorView = document.getElementById('ask-analyst-error');

    let recaptchaLoaded = false;

    function loadRecaptcha() {
        if (recaptchaLoaded || window.grecaptcha) return;
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
        script.async = true;
        document.head.appendChild(script);
        recaptchaLoaded = true;
    }

    function openModal() {
        modal.classList.remove('hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
        loadRecaptcha(); // Dynamically load reCaptcha
    }

    function closeModal() {
        modal.classList.add('hidden');
        document.body.style.overflow = '';
        
        // Reset form UI state on close (preserve draft text unless successfully submitted)
        setTimeout(() => {
            if (!successView.classList.contains('hidden')) {
                form.reset();
                form.style.display = 'block';
                successView.classList.add('hidden');
            }
            errorView.classList.add('hidden');
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send Query';
        }, 300);
    }

    // Close on X button
    closeBtn.addEventListener('click', closeModal);
    successCloseBtn.addEventListener('click', closeModal);

    // Close on backdrop click
    modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
            closeModal();
        }
    });

    // 3. Handle Form Submission
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        errorView.classList.add('hidden');
        submitBtn.disabled = true;
        const originalText = submitBtn.textContent;
        submitBtn.textContent = 'Sending...';

        const formData = new FormData(form);
        const dataObj = Object.fromEntries(formData.entries());

        const payload = {
            formType: "ask_analyst",
            formId: form.id,
            timestamp: new Date().toISOString(),
            data: dataObj
        };
        
        try {
            // Generate reCaptcha token
            const recaptchaToken = await new Promise((resolve, reject) => {
                if (!window.grecaptcha) {
                    reject(new Error('reCAPTCHA not loaded'));
                    return;
                }
                grecaptcha.ready(() => {
                    grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: 'ask_an_analyst'})
                        .then(resolve)
                        .catch(reject);
                });
            });

            const response = await fetch(ASK_ANALYST_SUBMIT_URL, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Recaptcha-Token': recaptchaToken
                }
            });

            if (response.ok) {
                // Success
                form.style.display = 'none';
                successView.classList.remove('hidden');
            } else {
                // Error from server
                throw new Error('Server responded with an error');
            }
        } catch (error) {
            console.error('Ask an Analyst submission failed:', error);
            errorView.classList.remove('hidden');
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
        }
    });
});
